import type { ContentType } from '@prisma/client';
import { z } from 'zod';
import { Content, ContentConversationListItem } from './content.js';
import { Tracking } from './tracking.js';

export interface ContentAttachment {
  parentContentId: number;
  childContentId: number;
  parentContentType: ContentType;
  childContentType: ContentType;
  createdAt: string;
}

type ContentWithOptionalTracking = Omit<Content, 'tracking'> & { tracking?: Tracking };

export interface ContentAttachmentListResult {
  items: ContentWithOptionalTracking[];
  /**
   * The MESSAGE entries of `items`, grouped into conversations and resolved against
   * their full threads. Attached messages are thread roots, so this is what carries the
   * thread's participants and message count — `items` keeps the raw rows.
   */
  messageConversations: ContentConversationListItem[];
}

export const contentAttachmentCreateSchema = z.object({
  childContentId: z.number().int().positive(),
});

export type ContentAttachmentCreateInput = z.infer<typeof contentAttachmentCreateSchema>;
